<template>
    <div v-loading="loading">
        <div id="printContent" class="print-zone">
            <div class="print-for" v-bind:key="item.SetOrderId" v-for="item in printList">
                <div class="print-title-view">
                    <div class="order-code">
                        <canvas id="canvas" class="qrcode-canvas" ref="canva"></canvas>
                        <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" />
                    </div>
                    <div class="print-title">组装单</div>
                    <div class="order-detail">
                        <div class="right">单号：{{ orderdata.SetOrderCode }}</div>
                        <div class="right">
                            期限日期：
                            <span>{{ orderdata.NeedTime }}</span>
                        </div>
                    </div>
                </div>
                <div class="print-table-main">
                    <el-table :data="tableData" border class="fkyou" header-row-class-name="fkyou" style="width: 100%" :span-method="objectSpanMethod">
                        <el-table-column label="序号" width="52px" sortable type="index"> </el-table-column>
                        <el-table-column prop="SetCode" label="套包编码"> </el-table-column>
                        <!-- <el-table-column prop="SetName" label="套包名称"> </el-table-column> -->
                        <el-table-column prop="APCode" label="汽配编码"> </el-table-column>
                        <el-table-column prop="GoodName" show-overflow-tooltip label="配件名称"> </el-table-column>
                        <el-table-column prop="AutoSerise" show-overflow-tooltip label="适用车型"> </el-table-column>
                        <!-- <el-table-column width="60px" label="需求数量">
              <template slot-scope="scope">
                {{ scope.row.Count + scope.row.Unit }}
              </template>
            </el-table-column> -->
                        <el-table-column width="60px" label="数量">
                            <template slot-scope="scope">
                                {{ scope.row.TotalCount + scope.row.Unit }}
                            </template>
                        </el-table-column>

                        <el-table-column prop="GoodsLocation" width="100px" label="仓位"> </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div class="re-submit">
            <el-button class="btn-primary" @click="printedRecord" v-print="'#printContent'">打印</el-button>
            <el-button @click="cancel()">关闭</el-button>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
export default {
    name: '',
    components: {},
    props: {
        printIds: {
            type: Array
        },
        printType: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            loading: false,
            printList: [],
            orderdata: [],
            imgUrl: '',
            spanArr: [],
            pos: 0,
            tableData: []
        };
    },
    watch: {
        printList(value) {
            this.$nextTick(function () {
                try {
                    let canvas = this.$refs.canva[0];
                    QRCode.toCanvas(
                        canvas,
                        value[0].SetOrderCode,
                        {
                            width: 80,
                            height: 80,
                            margin: 0,
                            scrollX: 0,
                            scrollY: 0
                        },
                        function (error) {}
                    );

                    setTimeout(() => {
                        html2canvas(canvas, {
                            width: 80,
                            height: 80,
                            scrollX: 0,
                            scrollY: 0
                        }).then(canvasRes => {
                            var imgData = canvasRes.toDataURL('image/png');
                            this.imgUrl = imgData;
                            canvas.style.display = 'none';
                        });
                    }, 1000);
                } catch (e) {
                    //
                }
            });
        }
    },
    mounted() {
        this.getSetOrder();
    },
    methods: {
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord(
                    {
                        OrderId: this.printIds[0],
                        Type: 5
                    },
                    true
                )
                .then(res => {})
                .finally(() => {
                    this.loading = false;
                });
        },
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        // 获取表格数据
        getSetOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetEnterprisePrintSetOrderDatas',
                    data: {
                        SetOrderId: this.printIds[0],
                        EntpId: this.$util.getLocalStorage('userMsg').EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.printList.push(res.data);
                    this.orderdata = res.data;
                    this.tableData = res.data.DetailList;
                    this.getSpanArr();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getSpanArr() {
            // data就是我们从后台拿到的数据
            for (var i = 0; i < this.tableData.length; i++) {
                if (i === 0) {
                    this.spanArr.push(1);
                    this.pos = 0;
                } else {
                    // 判断当前元素与上一个元素是否相同
                    if (this.tableData[i].SetCode === this.tableData[i - 1].SetCode) {
                        this.spanArr[this.pos] += 1;
                        this.spanArr.push(0);
                    } else {
                        this.spanArr.push(1);
                        this.pos = i;
                    }
                }
            }
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0 || columnIndex === 1) {
                const _row = this.spanArr[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return {
                    // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                    rowspan: _row,
                    colspan: _col
                };
            }
        }
    }
};
</script>
<style lang="less">
.el-table th {
    padding-right: 0px;
}
.el-table .cell {
    padding-right: 0px;
}
.fkyou div {
    color: #000;
}
.fkyou {
    border: 1px solid #000;
    margin-bottom: 10px;
}
.fkyou td {
    padding: 1px;
    border-right: 1px solid #000;
    border-top: 1px solid #000;
}
.fkyou th {
    padding: 1px;
    border-right: 1px solid #000;
}
</style>
<style lang="less" scoped media="print">
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px 0;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
}

.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.re-submit {
    text-align: right;
    margin-top: 0;
}

.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}

.print-table-main {
    width: 792px;
    margin-left: 1px;
    font-size: 12px;
}
</style>
